import { render, staticRenderFns } from "./home-blog-posts.vue?vue&type=template&id=34b7876c&scoped=true&"
import script from "./home-blog-posts.vue?vue&type=script&lang=js&"
export * from "./home-blog-posts.vue?vue&type=script&lang=js&"
import style0 from "./home-blog-posts.vue?vue&type=style&index=0&id=34b7876c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34b7876c",
  null
  
)

export default component.exports